import api from "@/requests";

/* OTP - One Time Password */

/**
 * Request SMS code
 *
 * @param {Object} SmsParameters
 * @param {string} SmsParameters.otpCodeName --> required
 */
export const sendSmsRequest = async (SmsParameters) =>
  api.post(`/api/v1/mybank/SendSms`, {
    SmsParameters,
  });

export const checkSmsRequest = async (SmsCodeRawValue) =>
  api.post(`/api/v1/mybank/CheckSms`, {
    SmsCodeRawValue,
  });
